import React from 'react';

export const formatWeight = grams => Number.isFinite(Number(grams)) && Number(grams) > 0
  ? `${Number(grams) > 999 ? Number((Number(grams) / 1000).toFixed(3)).toLocaleString() + ' kg' : Number(grams).toLocaleString() + ' g'}`
  : 'Weight not provided';

export default function WeightInfo({ weightGrams, weightNote }) {
  return <p className="mt-1 text-xs text-slate-500">{formatWeight(weightGrams)}{weightNote ? ` · ${weightNote}` : ''}</p>;
}

export function TotalWeight({ items, grams }) {
  const total = items ? items.length && items.every(item => Number(item.weightGrams) > 0)
    ? items.reduce((sum, item) => sum + Number(item.weightGrams) * Number(item.qty ?? item.quantity ?? 1), 0) : null : grams;
  return <p className="mt-2 text-sm font-medium text-slate-600">Total weight: {formatWeight(total)}</p>;
}
